import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49347c26"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name"]
const _hoisted_2 = { class: "accordion-item__title" }
const _hoisted_3 = {
  key: 0,
  class: "accordion-item__sub-title"
}

import IconChevronDown from "@/components/icons/IconChevronDown.vue";
import { injectAccordion } from ".";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressAccordionItem',
  props: {
    title: {},
    subTitle: {}
  },
  setup(__props: any) {



const { groupName, dense } = injectAccordion();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", {
    name: _unref(groupName),
    class: "accordion-item"
  }, [
    _createElementVNode("summary", {
      class: _normalizeClass(["accordion-item__summary", { 'accordion-item__summary--dense': _unref(dense) }])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
        (_ctx.subTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.subTitle), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(IconChevronDown, { class: "accordion-item__icon" })
    ], 2),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})